
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Quotation } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class QuotationEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    quotation: Quotation;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getQuotation()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getQuotation(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('quotation/' + this.routeParams.id).subscribe({
                    next: (res: Quotation) => {
                        this.quotation = res;
                        this.onDataChanged.next(this.quotation);
                        resolve(res);
                    },
                    error: (err: any) => { reject(err) }
                });
            }
        });
    }

    insert(quotation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('quotation/', quotation).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage("Dados Salvos com sucesso");
                },
                error: (err: any) => { reject(err) }
            });
        });
    }

    edit(quotation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('quotation/', quotation).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage("Dados atualizados com sucesso");
                },
                error: (err: any) => { reject(err) }
            });
        });
    }

    delete(quotation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('quotation/', quotation).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage("Dados atualizados com sucesso");
                },
                error: (err: any) => { reject(err) }
            });
        });
    }
}
